import { ReportAttachment } from 'src/modules/report/types/ReportAttachment';
import { ReportData } from 'src/modules/report/types/ReportData';
import { ReportFormData } from 'src/modules/report/types/ReportFormData';
import { createActions } from 'src/utils/createActions';
import { createTrigger } from 'src/utils/createTrigger';

export const REPORT_FETCH = createTrigger<ReportData>('REPORT_FETCH');
export const REPORT_RESET = createTrigger<void>('REPORT_RESET');

export const REPORT_CHANGE = createTrigger<ReportFormData>('REPORT_CHANGE');
export const REPORT_GENERATE = createActions<ReportFormData, void>('REPORT_GENERATE');

export const REPORT_ATTACHMENT_PROCESS =
  createActions<File, ReportAttachment>('REPORT_ATTACHMENT_PROCESS');
export const REPORT_ATTACHMENT_DELETE =
  createTrigger<ReportAttachment>('REPORT_ATTACHMENT_DELETE');
